@use "~theme/breakpoints";

.container {
  @include breakpoints.desktop {
    max-width: 456px;
  }
}

.message {
  margin: 0 auto;
  width: 280px;

  @include breakpoints.desktop {
    width: 100%;
  }
}

.button {
  width: 100%;
}
